export const geoApiOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': 'a82cdaaad2msh735b65e6bc4d99dp1f8a3ejsn48635fc70e74',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo"

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5"

export const WEATHER_API_KEY = "3fe05fe37f4993bdca04d6ae6633872f";
// export const WEATHER_API_KEY = "";